'use strict';

import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import LogoSmall from '../../../common/svgs/LogoSmall';
import MenuIcon from '../../../common/svgs/MenuIcon';
import ContactIcon from '../../../common/svgs/ContactIcon';
import CandidateIcon from '../../../common/svgs/CandidateIcon';
import CompanyIcon from '../../../common/svgs/CompanyIcon';
import JobRequestIcon from '../../../common/svgs/JobRequestIcon';
import Settings from '../../../common/svgs/Settings';
import {get} from 'lodash';
import * as ui from '../../../redux/actionCreators/sync/ui';

@connect((store) => ({
  user: store.user
}))
export default class NavigationAdmin extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    user    : PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen : false
    };
  }

  toggleNavigation = () => {
    this.setState({isOpen: !this.state.isOpen});
  }

  handleClick = (event, url) => {
    this.props.dispatch(ui.showSpinner());
    this.props.dispatch(push(url));
  }

  isActiveSection(path) {
    return (this.props.location.pathname.toLowerCase().startsWith(path.toLowerCase()));
  }

  isActiveSections(paths) {
    return !!~paths.indexOf(this.props.location.pathname.toLowerCase());
  }

  render() {

    const roles = get(this.props.user, 'roles', []);
    const isAdmin = roles.includes('Admin');

    return (
      <div className={`navigation-admin ${(this.state.isOpen) ? ' open' : ''}`}>
        <LogoSmall collapsed={!this.state.isOpen} className='navigation-admin-logo' style={{color: '#fefefe', backgroundColor: '#161a21'}}/>
        <ul className='navigation-admin-list'>
          <li data-id='admin-nav-candidate' className={this.isActiveSections(['/admin/in process', '/admin/inactive', '/admin/qualified',  '/admin/standby']) ? 'active' : ''}
              onClick={(event) => this.handleClick(event, '/admin/In Process')}>
            <CandidateIcon />
            <label>Candidates</label>
          </li>
          <li data-id='admin-nav-contact' className={this.isActiveSection('/admin/contacts') ? 'active' : ''}
              onClick={(event) => this.handleClick(event, '/admin/contacts')}>
            <ContactIcon />
            <label>Contacts</label>
          </li>
          <li data-id='admin-nav-company' className={this.isActiveSection('/admin/companies') ? 'active' : ''}
            onClick={(event) => this.handleClick(event, '/admin/companies/')}>
            <CompanyIcon />
            <label>Companies</label>
          </li>
          <li data-id='admin-nav-jobrequest' className={this.isActiveSection('/admin/jobrequests') ? 'active' : ''}
            onClick={(event) => this.handleClick(event, '/admin/jobrequests')}>
            <JobRequestIcon />
            <label>Job Requests</label>
          </li>
          {isAdmin && <li data-id='admin-nav-settings' className={this.isActiveSection('/admin/settings/') ? 'active' : ''}
            onClick={(event) => this.handleClick(event, '/admin/settings/users')}>
            <Settings />
            <label>Settings</label>
          </li> }
        </ul>
        <ul className='navigation-admin-list menu'>
          <li data-id='admin-nav-add-contact' className={this.isActiveSection('/admin/Prospect') ? 'active' : ''}
              onClick={(event) => this.handleClick(event, '/admin/Prospect')}>
            <ContactIcon showPlus />
            <label>Add Contact</label>
          </li>
          <li data-id='admin-nav-toggle' onClick={this.toggleNavigation}>
            <MenuIcon isOpen={this.state.isOpen} />
            <label>Close</label>
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Navigation/index.js